import { HoverHintDefinitionGrid } from "@/components/ui/HoverHintDefinitionGrid";

import type { HubBomLine, HubBomResponse } from "./assemblyApi";

function assemblyHubBomSourceLabel(
  bomMeta: Pick<HubBomResponse, "source" | "reference_sku"> | null | undefined,
): string {
  switch (bomMeta?.source) {
    case "hub_output_sku":
      return "Hub bill of materials (rule-resolved)";
    case "hub_source_tla":
      return `Input TLA hub BOM (${bomMeta.reference_sku ?? "source"})`;
    case "megaventory_product":
      return "Megaventory product BOM";
    case "megaventory_source_tla":
      return `Input TLA Megaventory product BOM (${bomMeta.reference_sku ?? "source"})`;
    case "mg_shp_template":
      return "Hub MG-SHP template BOM";
    default:
      return "Bill of materials";
  }
}

export function AssemblyHubBomHoverHint({
  lines,
  bomMeta,
  loading,
  errorMessage,
}: {
  lines: HubBomLine[];
  bomMeta?: Pick<HubBomResponse, "source" | "reference_sku" | "note"> | null;
  loading?: boolean;
  errorMessage?: string | null;
}): JSX.Element {
  if (loading) {
    return <p className="text-xs text-slate-600">Loading bill of materials…</p>;
  }
  if (errorMessage != null && errorMessage.trim() !== "") {
    return <p className="text-xs text-slate-600">{errorMessage}</p>;
  }
  if (lines.length === 0) {
    return (
      <div className="space-y-2">
        <p className="text-xs text-slate-600">No bill of materials lines are available for this output SKU.</p>
        {bomMeta?.note ? <p className="text-xs text-slate-600">{bomMeta.note}</p> : null}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-slate-700">{assemblyHubBomSourceLabel(bomMeta)}</p>
      {bomMeta?.note ? <p className="text-xs text-slate-600">{bomMeta.note}</p> : null}
      <HoverHintDefinitionGrid
        rows={lines.map((line) => ({
          label: line.variable_name,
          value: (
            <span className="font-mono">
              {line.component_sku ?? "—"} × {String(line.quantity)}
            </span>
          ),
        }))}
      />
    </div>
  );
}
